import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { fetchVacancies } from "../../../store/slices/vacanciesSlice";
import JoinTeamCard from "./JoinTeamCard";
import Loader from "../../../components/base-components/Loader";
import NoData from "../../../components/base-components/NoData";
import ErrorMessage from "../../../components/base-components/Error";
import { VacancyResponse } from "../../../store/types/vacancies-types";

interface Props {
  setSubject: (subject: string) => void;
}

const Vacancies: React.FC<Props> = ({ setSubject }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { vacancies, status, error } = useSelector(
    (state: RootState) => state.vacancies
  );

  useEffect(() => {
    dispatch(fetchVacancies());
  }, [dispatch]);

  if (status === "loading") return <Loader />;
  if (status === "failed")
    return <ErrorMessage message={error || "Load error"} />;
  if (!vacancies.length) return <NoData message="Vacancy not found" />;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[2rem] w-full">
      {vacancies.map((vacancy: VacancyResponse) => (
        <JoinTeamCard
          key={vacancy.id}
          title={vacancy.attributes.name}
          level={vacancy.attributes.Level}
          description={vacancy.attributes.shortDescription}
          onApply={setSubject}
        />
      ))}
    </div>
  );
};

export default Vacancies;
